import { DomService } from '../dom';

interface Query {
  search: string;
  page: number;
  filters: {
    Category: string[]
  }
  perPage: number;
  enableFacetFiltering?: boolean;
}

export const CludoSearchService = {
  async query({
    search, filters, page, perPage = 6, enableFacetFiltering = true,
  }: Query) {
    const { cludoCustomerId, cludoEngineId } = DomService.getDOMGlobalConfig();

    // eslint-disable-next-line compat/compat
    return fetch(
      `https://api.cludo.com/api/v3/${cludoCustomerId}/${cludoEngineId}/search`,
      {
        method: 'POST',
        headers: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'Content-Type': 'application/json',
          Authorization: `SiteKey ${btoa(`${cludoCustomerId}:${cludoEngineId}:SiteKey`)}`,
        },
        body: JSON.stringify({
          // Use cludo fuzzyness only if there are special characters in the query term
          query: search.match('[^\x00-\x7F]') ? `${search}~ ` : `${search}`,
          perPage,
          page,
          enableFacetFiltering,
          filters,
        }),
      },
    )
      .then((response) => response.json())
      .catch(() => ({}));
  },
};
